import { Component } from '@angular/core';

@Component({
  selector: 'app-startup-logo',
  standalone: true,
  imports: [],
  templateUrl: './startup-logo.component.html',
  styleUrl: './startup-logo.component.scss'
})
export class StartupLogoComponent {

}
